/** @jsx jsx */
import IconError from '@apollo/icons/default/IconError.svg';
import IconSuccess from '@apollo/icons/default/IconSuccess.svg';
import IconWarning from '@apollo/icons/default/IconWarning.svg';
import { Spinner, customColors } from '@apollo/orbit';
import { jsx } from '@emotion/react';
import classnames from 'classnames';

import { assertUnreachable } from 'src/lib/assertUnreachable';

type Props = {
  className?: string;
  status: 'PASSED' | 'FAILED' | 'PENDING' | 'WARNING';
};

export const CheckWorkflowStatusIcon = ({ status, className }: Props) => {
  switch (status) {
    case 'FAILED':
      return (
        <IconError
          className={classnames(className)}
          style={{ color: customColors.icon.error }}
        />
      );
    case 'WARNING':
      return (
        <IconWarning
          className={classnames(className)}
          style={{ color: customColors.icon.warning }}
        />
      );
    case 'PASSED':
      return (
        <IconSuccess
          className={classnames(className)}
          style={{ color: customColors.icon.success }}
        />
      );
    case 'PENDING':
      return <Spinner size="tiny" className={classnames(className)} />;
    default:
      assertUnreachable(status);
  }
};
